import { render } from "./pointeusePdf.vue?vue&type=template&id=3375ab86"
import script from "./pointeusePdf.vue?vue&type=script&lang=js"
export * from "./pointeusePdf.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__